import { DateTime } from 'luxon';

const formatStart = (time: DateTime) => {
	if (!time.isValid) {
		return '';
	}
	if (DateTime.now().hasSame(time, 'day')) {
		return 'Today';
	}

	if (DateTime.now().minus({ days: 1 }).hasSame(time, 'day')) {
		return 'Yesterday';
	}

	return `${time.toFormat('ccc, dd LLL')}`;
};

const formatEnd = (time: DateTime) => {
	if (!time.isValid) {
		return '';
	}

	if (DateTime.now().hasSame(time, 'day')) {
		return 'Today';
	}

	if (DateTime.now().minus({ days: 1 }).hasSame(time, 'day')) {
		return 'Yesterday';
	}

	return `${time.toFormat('ccc, dd LLL')}`;
};

const formatCompleted = (time: DateTime) => {
	if (DateTime.now().hasSame(time, 'day')) {
		return `Today ${time.toFormat('HH:mm')}`;
	}

	if (DateTime.now().minus({ days: 1 }).hasSame(time, 'day')) {
		return `Yesterday, ${time.toFormat('HH:mm')}`;
	}

	return `${time.toFormat('ccc, dd LLL')}, ${time.toFormat('HH:mm')}`;
};

export default {
	formatStart,
	formatEnd,
	formatCompleted,
};
